import {main, routes} from './main.js';
import {requestJSON} from './utils.js';

let popup;
let map;

function showMap()
{
	main.innerHTML = '';

	let locateButton = document.createElement("button");
	locateButton.type = "button";
	locateButton.classList.add("btn");
	locateButton.insertAdjacentHTML("afterbegin", `<i class="fas fa-location-arrow"></i> Moje poloha`);
	let mapElem = document.createElement("div");
	mapElem.id = "map";
	main.appendChild(locateButton);
	main.appendChild(mapElem);
	map = L.map('map').setView([49.217, 17.67], 13);

	let OpenTopoMap = L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
		maxZoom: 16,
		attribution: 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
	});

	OpenTopoMap.addTo(map);

	map.addEventListener('locationfound', onLocationFound);
	map.addEventListener('locationerror', onLocationError);

	locateButton.addEventListener("click", function () {
		map.locate({setView: true, maxZoom: 16});
	});

	popup = L.popup();

	//map.addEventListener('click', onMapClick);

	requestJSON('POST', routes["photo.list"], {after: "0", format: "geojson"}, function (xhr) {
		let photos = xhr.response;
		let photosLayer = L.geoJSON(photos, {onEachFeature: onEachFeature}).addTo(map);
	});
}

function onEachFeature(feature, layer) {
	layer.bindPopup(`<div style="width: 160px"><img src="${feature.properties.thumbnail.w160}" alt="${feature.properties.filename}"></div>`);
}

function onLocationFound(e)
{
	let radius = e.accuracy / 2;

	L.marker(e.latlng).addTo(map)
		.bindPopup("You are within " + radius + " meters from this point").openPopup();

	L.circle(e.latlng, radius).addTo(map);

	let track = [];
	let trackJson = localStorage.getItem("track");
	if (trackJson !== null) {
		track = JSON.parse(trackJson);
	}
	track.push({
		lat: e.latlng.lat,
		lng: e.latlng.lng,
		alt: e.latlng.alt,
		accuracy: e.accuracy,
		altitude: e.altitude,
		altitudeAccuracy: e.altitudeAccuracy,
		heading: e.heading,
		speed: e.speed,
		timestamp: e.timestamp
	});
	localStorage.setItem("track", JSON.stringify(track));
}

function onLocationError(e)
{
	alert(e.message);
}
/*
function onMapClick(e) {
	popup
		.setLatLng(e.latlng)
		.setContent("You clicked the map at " + e.latlng.toString())
		.openOn(map);
}
*/
export {showMap};
